import React, { useState, useEffect } from 'react';
import { FiFileText, FiCheckCircle, FiEdit3 } from 'react-icons/fi';
import styles from '../StudyManagement.module.css';
import { getSubjectStats } from '../../../Config/api';

const iconMap = {
    'Total Enrollments': FiFileText,
    'Included': FiEdit3,
    'Completed': FiCheckCircle,
    'Excluded': FiEdit3
};

const colorMap = {
    'Total Enrollments': '#3b82f6', // blue
    'Included': '#f59e0b', // amber
    'Completed': '#10b981', // green
    'Excluded': '#ef4444' // red
};

const StatCard = ({ title, value, subValue }) => {
    const Icon = iconMap[title];
    const color = colorMap[title];

    return (
        <div className={styles.statCard}>
            <div className={styles.statIcon} style={{ backgroundColor: `${color}15`, color: color }}>
                <Icon />
            </div>
            <div className={styles.statContent}>
                <h3 className={styles.statTitle}>{title}</h3>
                <p className={styles.statValue}>{value}</p>
                {subValue && <p className={styles.statSubValue}>{subValue}</p>}
            </div>
        </div>
    );
};

const EnrollmentCards = ({ subjects, studyData, userSite, userRole }) => {
    const [statsData, setStatsData] = useState({
        totalEnrolments: studyData?.total_enrolled || 0,
        included: studyData?.included || 0,
        completed: studyData?.completed || 0,
        excluded: studyData?.excluded || 0
    });

    useEffect(() => {
        const fetchStats = async () => {
            try {
                // Determine dashboard parameter based on role
                let dashboardParam = "dataCapture"
                console.log('User Role:', userRole);
                console.log('Sending dashboard param:', dashboardParam);

                const response = await getSubjectStats({
                    dashboard: dashboardParam
                });

                console.log('API Response:', response);

                // Check if response has the correct structure
                if (response) {
                    const stats = response;
                    setStatsData({
                        totalEnrolments: stats.total_enrolled || 0,
                        included: stats.included || 0,
                        completed: stats.completed || 0,
                        excluded: stats.excluded || 0
                    });
                }
            } catch (error) {
                console.error('Error fetching enrollment stats:', error);
            }
        };
        if (userRole) {
            fetchStats();
        }
    }, [userRole, subjects.length]);

    const stats = [
        {
            title: 'Total Enrollments',
            value: statsData.totalEnrolments,
            subValue: 'All Subjects'
        },
        {
            title: 'Included',
            value: statsData.included,
            subValue: 'Included Subjects'
        },
        {
            title: 'Completed',
            value: statsData.completed,
            subValue: 'Completed Subjects'
        },
        {
            title: 'Excluded',
            value: statsData.excluded,
            subValue: 'Excluded Subjects'
        }
    ];

    return (
        <div className={styles.cardsSection}>
            <div className={styles.statsGrid}>
                {stats.map((stat, index) => (
                    <StatCard
                        key={index}
                        title={stat.title}
                        value={stat.value}
                        subValue={stat.subValue}
                    />
                ))}
            </div>
        </div>
    );
};

export default EnrollmentCards;